// iOS aborts the soft-keyboard *open* animation if the focused input's
// position:fixed container is repositioned mid-animation — which is exactly what
// a visual-viewport pin does (it rewrites the container's top/height the instant
// the keyboard resizes the viewport). The result on iPhone: the caret appears
// but the keyboard never does. Both entry points pin (the floating widget panel
// in App.tsx, the #root of the /mobile embed in mobile.tsx), so both need this
// guard — fixing only one leaves the other surface dead. Android has no such
// quirk and keeps the pin, which lifts the composer above the keyboard.
export function detectIOS(userAgent: string, hasTouch: boolean): boolean {
  if (/iPad|iPhone|iPod/.test(userAgent)) return true;
  // iPadOS 13+ reports as desktop Safari; disambiguate via touch support.
  return userAgent.includes("Macintosh") && hasTouch;
}

export const IS_IOS =
  typeof navigator !== "undefined" &&
  typeof document !== "undefined" &&
  detectIOS(navigator.userAgent, "ontouchend" in document);
